import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Box, IconButton, Tooltip
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../context/AuthContext';
import { DataGrid } from '@mui/x-data-grid';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import {useSnackbar} from 'notistack';


export default function SyncMoneyListsProteys() {
  const { setLoading, setNotification } = useAuthContext();
  const navigate = useNavigate();
  const { setLoggedInUser } = useAuthContext();
  const [responseData, setResponseData] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const [rows, setRows] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/moneyListsStatusProteys`,
          {
            withCredentials: true,
          },
        );
        setLoading(false);
        setResponseData(response.data);
        setRows(response.data);
      } catch (error) {
        setLoading(false);
        setNotification({
          message: error.response.data.message,
          open: true,
          color: 'error',
        });
        if (error.response.status == 401) {
          setLoggedInUser(null);
          navigate('/login');
        }
        console.error(error);
      }
    })();
  }, []);

  const columns = [
    { field: 'CD_USE', headerName: 'Έτος', width: 70, headerClassName: 'super-app-theme--header' },
    { field: 'MONEY_LIST_TYPE', headerName: 'Τύπος Καταλόγου', flex: 1, headerClassName: 'super-app-theme--header' },
    { field: 'TRANSFER_FLAG_DESCR', headerName: 'Κατάσταση Καταλόγου', flex: 1, headerClassName: 'super-app-theme--header' },
    { field: 'MONEY_LIST_SYNC_STATUS', headerName: 'Κατάσταση Συγχρονισμού Καταλόγου', flex: 1, headerClassName: 'super-app-theme--header' }
  ];

  const clearCatalogue = async (row) => {
    setLoading(true);
    try {
      const deleteResp = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/deleteMoneyList`,
        { id: row.id , cdUse: row.CD_USE},
        { withCredentials: true }
      );

      if (deleteResp.status === 200 && deleteResp.data.deleteSuccess) {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/moneyListsStatusProteys`,
          {
            withCredentials: true,
          },
        );
        setRows(response.data);
        setLoading(false);
        enqueueSnackbar('Ο Χρηματικός Κατάλογος Διαγράφηκε', { variant: 'success' });
      } else {
        enqueueSnackbar('Ο Χρηματικός Κατάλογος δεν Διαγράφηκε: ' + deleteResp.data.message , { variant: 'error' });
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar(
        error?.response?.data ||
          'Παρουσιάστηκε σφάλμα κατά την διαγραφή του Χρηματικού καταλόγου',
        { variant: 'error' },
      );
    }
  };

  return (
    <>
      {responseData
        ? (
          <Box>
            <Box
              sx={{
                textAlign: {xs: 'center', md: 'start'},
                marginTop: '5em',
                marginLeft: {xs: '0em', md: '5em'}, marginBottom: '5em',
              }}
            >
              <h2>Χρηματικοί Κατάλογοι που έχουν δημουργηθεί στον Πρωτέα</h2>
            </Box>
            <Box sx={{height: 400, width: '100%',
              '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 'bold',
              },}}>
              <DataGrid
                rows={rows.moneyListsStatus}
                columns={[
                  ...columns,
                  {
                    field: 'action',
                    headerName: 'Ενέργεια',
                    flex: 0.5,
                    sortable: false,
                    minWidth: 200,
                    renderCell: (e) => {
                      return (
                        <Box display= {(e.row.TRANSFER_FLAG === 0 || e.row.MONEY_LIST_SYNC_STATUS === 'Συγχρονισμός σε εξέλιξη')
                          ? 'none'
                          : 'flex'} gap={2}>
                          <Box>
                            <Tooltip title={'Διαγραφή Συγχρονιμένου Χρηματικού Καταλόγου'}>
                              <IconButton
                                color={'error'}
                                disabled={Object.values(e.row).some(
                                  (x) => !String(x),
                                )}
                                onClick={() => {
                                  clearCatalogue(e.row);
                                }}
                              >
                                <DeleteForeverIcon />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </Box>
                      );
                    },
                  },
                ]}
                pageSize={5}
                rowsPerPageOptions={[5]}
              />
            </Box>
          </Box>
        )
        : (
          <Box height='100%'></Box>
        )}
    </>
  );

}
